import React from 'react'
import './index.css'
import OpenAccountImg from '../../imgs/guidePage_openAccount.png';
import tradeImg from '../../imgs/guidePage_trade.png'
import icon_guidePage from '../../imgs/icon_guidePage.png'

export const GuidePageType = {
    OpenAccount: 'OPENACCOUNT', //开户
    Trade: "TRADE", //交易
}

let GuidePageRef = {current: null}
class GuidePage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            active: false
        }
        this.guideType = GuidePageType.Trade
    }

    show = (type) => {
        this.guideType = type
        this.setState({ active: true })
    }

    onCloseView = () => {
        this.setState({ active: false })
    }

    render() {
        if (!this.state.active) return null
        return (
            <div className='guide_page'>
                <div className='guide_page_top'></div>
                <div className='guide_page_close' onClick={this.onCloseView}>
                    <img className='guide_page_image_icon' src={icon_guidePage}/>
                </div>
                {
                    this.guideType === GuidePageType.OpenAccount ? (
                        <img className='guide_page_image' src={OpenAccountImg} />
                    ) : (
                        <img className='guide_page_image' src={tradeImg} />
                    )
                }
            </div>
        )
    }
}

const Guide = {
    show: (type) => {
        GuidePageRef.current && GuidePageRef.current.show(type);
    },
    leave: () => {
        GuidePageRef.current && GuidePageRef.current.onCloseView();
    }
}
export default Guide
export { GuidePage, GuidePageRef }


// WEBPACK FOOTER //
// ./src/components/guidePage/index.js